import { Typeahead } from "react-bootstrap-typeahead";
import { Boundary, useBoundaries } from "../../context/boundary";
import { Option } from "react-bootstrap-typeahead/types/types";
import { useEffect, useState } from "react";
import { useMap } from "../../context/map";
import { getCenter } from "ol/extent";
import { useNavigate } from "react-router-dom";

const BoundaryTypeahead = () => {
  const {
    boundaries,
    selectedBoundary,
    setSelectedBoundary,
    setOverlayCoordinate,
  } = useBoundaries();

  const { map } = useMap();

  const [localSelected, setLocalSelected] = useState<Boundary[]>([]);

  const navigate = useNavigate();

  const handleChange = (selected: Option[]) => {
    setLocalSelected(selected as Boundary[]);
    if (selected.length > 0) {
      const boundary = selected[0] as Boundary;
      setSelectedBoundary(boundary);
      map?.getView().fit(boundary.envelope, {
        duration: 1000,
        padding: [320, 80, 80, 80],
      });
      const center = getCenter(boundary.envelope);
      setOverlayCoordinate(center);
      navigate(`/boundary/${boundary.urlTag}`, {
        state: { autoFocus: false },
      });
    } else {
      setSelectedBoundary(undefined);
      setOverlayCoordinate(undefined);
    }
  };

  useEffect(() => {
    if (selectedBoundary?.id !== localSelected[0]?.id) {
      setLocalSelected([]);
    }
  }, [selectedBoundary]);

  return (
    <Typeahead
      onChange={handleChange}
      options={boundaries ?? []}
      selected={localSelected}
      placeholder="Search for boundaries"
      clearButton
      labelKey="name"
    />
  );
};

export default BoundaryTypeahead;
